import { del, get, post, put } from '../../api-config';
import { gdpService } from './_service';

// Feature expedientes (F5): el expediente persistente vive en gdp — detalle con eventos,
// resolución (POST y PUT son el mismo upsert idempotente en backend) y notas de expediente.

export const getExpedient = async (expedientId: any) =>
  await get(gdpService, `/expedients/${expedientId}`, null, null);

// F6: expediente al que pertenece un evento (measureRawId o deviceActionId — en gdp
// ambos son EVENTS.ID). Abre el diálogo de expediente desde cualquier superficie.
export const getExpedientByEvent = async (eventId: any) =>
  await get(gdpService, `/events/${eventId}/expedient`, null, null);

export const getPatientExpedients = async (patientId: any, init?: any, size?: any) =>
  await get(gdpService, `/patients/${patientId}/expedients`, null, { init, size });

export const postExpedientResolution = async (data: any) =>
  await post(gdpService, `/expedients/${data.expedientId}/resolution`, data.body, null);

export const putExpedientResolution = async (data: any) =>
  await put(gdpService, `/expedients/${data.expedientId}/resolution`, data.body, null);

export const getExpedientResolution = async (expedientId: any) =>
  await get(gdpService, `/expedients/${expedientId}/resolution`, null, null);

export const getExpedientResolutionHistoric = async (expedientId: any) =>
  await get(gdpService, `/expedients/${expedientId}/resolution/historic`, null, null);

export const getExpedientNotes = async (expedientId: any, init?: any, size?: any) =>
  await get(gdpService, `/expedients/${expedientId}/notes`, null, { init, size });

// F8b (gestión unitaria, acuerdo RyC 2026-10-02): extrae los eventos seleccionados a un
// expediente NUEVO que nace con esa resolución y cerrado; el origen no se toca. Vale
// también sobre colectores ya autorresueltos. Devuelve el id del expediente nuevo.
export const postExpedientExtract = async (data: any) =>
  await post(gdpService, `/expedients/${data.expedientId}/extract`, data.body, null);

export const postExpedientNote = async (data: any) =>
  await post(gdpService, `/expedients/${data.expedientId}/notes`, data.body, null);

// Actividad por expedientes: búsqueda con filtros + facetas, mismo contrato que /events/search
// (vista general y ficha del paciente).
export const searchExpedients = async (data: any) => await post(gdpService, '/expedients/search', data, null);

export const searchPatientExpedients = async ({ id, ...data }: any) =>
  await post(gdpService, `/patients/${id}/expedients/search`, data, null);

// Seguir expedientes (incidencias-tecnicas F1): quién sigue un expediente, seguir / dejar de seguir,
// marcarlo visto al abrirlo, y el resumen de los seguidos con novedades (contador del menú).
export const getExpedientFollow = async (expedientId: any) =>
  await get(gdpService, `/expedients/${expedientId}/follow`, null, null);

export const putExpedientFollow = async (expedientId: any) =>
  await put(gdpService, `/expedients/${expedientId}/follow`, {}, null);

export const deleteExpedientFollow = async (expedientId: any) => await del(gdpService, `/expedients/${expedientId}/follow`);

export const postExpedientSeen = async (expedientId: any) =>
  await post(gdpService, `/expedients/${expedientId}/seen`, {}, null);

export const getFollowedExpedientsSummary = async () => await get(gdpService, '/expedients/followed/summary', null, null);

// «En espera» (incidencias-tecnicas F2): el expediente sale de la cola del SAC sin resolver (después va el terminate)
// y sigue abierto en gdp hasta que alguien lo resuelve. GET devuelve item null si nunca estuvo en espera.
export const postExpedientWaiting = async (expedientId: any) =>
  await post(gdpService, `/expedients/${expedientId}/waiting`, {}, null);

export const getExpedientWaiting = async (expedientId: any) =>
  await get(gdpService, `/expedients/${expedientId}/waiting`, null, null);
